/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import { ContainerTable, TableView } from "../../../components/Table";
import {
  getUserStakeInfo,
  getStakeEligible,
  getStakeTransaction,
  formatCurrency,
} from "../../../services/app";
import { useApp } from "../../../contexts";
import { CopyIcon } from "../../../components/Icons/CopyIcon";
import { Copy } from "../../../components/Copy";
import {
  SlideBannerContainer,
  SlideBannerOuterContainer,
  SwiperSlideWrapper,
  SwiperWraper,
} from "../../../pages/Home/styles";
import { Tooltip } from "antd";
import { InfoTooltipIcon } from "../../../pages/Home/styles";
import { ContainerTableStakeMobile, TextCellNormal } from "../styles";
import NumberFormat from "react-number-format";
import { CellRowImage } from "../styles";
import { useNavigate } from "react-router-dom";
import {
  DesktopContainer,
  MobileContainer,
} from "../../../components/Container";
import { RecordNotFound } from "../../../components/RecordNotFound";
import {
  dateFormatNumber,
  formatPercentage,
  getCoinCodeImage,
  RoundNumberOfDigitSGT,
} from "../../../utils/helper";
import { useWindowSize } from "../../../hook/useWindowSize";
import { CardSlideHeader } from "../../../components/StakeSlideHeader";
import moment from "moment";
import { WalletRowStake } from "./WalletRowStake";
import { StakingTabIcons } from "../../../components/Icons/StakingTabIcons";
import { FilterIcon } from "../../../components/Icons/FilterIcon";
import { FilterStake } from "./FilterStake";
import { LoadingList } from "../../../components/Loading2";
import EmptyTable from "../../../components/EmptyTable";
import EmptyTableMobile from "../../../components/EmptyTableMobile";

const PAGE_SIZES = {
  ACTIVE: 1000,
  HISTORY: 1000,
};

export const STAKE_SUB_TAB = {
  ACTIVE: 1,
  ELIGIBLE: 2,
  HISTORY: 3,
};

export const STAKE_TX_STATUS = {
  PENDING: 0,
  SUCCESS: 1,
  FAILED: 2,
  HOLDING: 3,
};

export const STAKE_TX_STATUS_OPTIONS = [
  {
    value: -1,
    label: "All",
    displayClassName: "",
  },
  // {
  //   value: STAKE_TX_STATUS.PENDING,
  //   label: "Pending",
  //   displayClassName: "stake-status-pending",
  // },
  // {
  //   value: STAKE_TX_STATUS.SUCCESS,
  //   label: "Success",
  //   displayClassName: "stake-status-success",
  // },
  {
    value: STAKE_TX_STATUS.HOLDING,
    label: "Holding",
    displayClassName: "stake-status-holding",
  },
  {
    value: STAKE_TX_STATUS.FAILED,
    label: "Stake Failed",
    displayClassName: "stake-status-failed",
  },
];

const SORT_BY = {
  amount: "amount",
  startTime: "start_date",
  claimTime: "end_date",
};

const SORT_TYPE = {
  ascend: "asc",
  descend: "desc",
};

export const StakeForOptionTable = () => {
  const { T, loading, language } = useApp();
  const navigate = useNavigate();
  const size = useWindowSize();
  const isMobile = size.width < 768;

  const [rows, setRows] = useState([]);
  const [viewEligibleOnly, setViewEligibleOnly] = useState(true);
  const [stats, setStats] = useState({});
  const [viewType, setViewType] = useState(STAKE_SUB_TAB.ACTIVE);
  const [showFilter, setShowFilter] = useState(false);
  const [filterParams, setFilterParams] = useState({});
  const [tabLoading, setTabLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [tableKey, setTableKey] = useState(0);
  const swiperRef = React.useRef(null);

  useEffect(() => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideTo(viewType - 1);
    }
  }, [viewType]);

  useEffect(() => {
    loadTabList();
    getUserStakeInfo().then((res) => {
      const data = res?.data;
      setStats(data);
    });
  }, [viewType]);

  useEffect(() => {
    loadData();
  }, [filterParams.sortBy, filterParams.sortType]);

  const loadTabList = async () => {
    try {
      setTabLoading(true);
      await loadData();
    } catch (e) {
    } finally {
      setTabLoading(false);
    }
  };

  const handleSearch = () => {
    loadData();
  };

  const handleTableChange = (pagination, filters, sorter) => {
    const { order, field } = sorter;
    setFilterParams({
      ...filterParams,
      sortBy: field,
      sortType: order,
    });
  };

  const handleReset = () => {
    setFilterParams({});
    setTableKey(tableKey + 1);
    loadData();
  };

  const handleViewTypeChange = (val) => {
    if (viewType === val) return;

    setRows([]);
    setFilterParams({});
    setShowFilter(false);
    setViewType(val);
  };

  const onChangeSwitch = () => {
    setViewEligibleOnly(!viewEligibleOnly);
  };

  const toggleFilter = () => {
    setShowFilter(!showFilter);
  };

  const getSlidePreview = () => {
    let preview = 0.8;
    if (size.width >= 1280) {
      preview = 2.75;
    } else if (size.width >= 1024) {
      preview = 2.4;
    } else if (size.width >= 890) {
      preview = 2.2;
    } else if (size.width >= 768) {
      preview = 2;
    } else if (size.width >= 576) {
      preview = 1.6;
    } else if (size.width >= 400) {
      preview = 1.31;
    } else if (size.width >= 340) {
      preview = 1.12;
    } else if (size.width >= 320) {
      preview = 1.1;
    }
    return preview;
  };

  const getSpaceBetween = () => {
    let distance = 30;
    if (size.width < 1024) {
      distance = 20;
    }
    return distance;
  };

  const formatFromDateParam = (date) => {
    return date ? moment(date).startOf("day").toISOString() : null;
  };

  const formatToDateParam = (date) => {
    return date ? moment(date).endOf("day").toISOString() : null;
  };

  const fetchDataActive = async ({ page }) => {
    const params = {
      status: STAKE_TX_STATUS.HOLDING,
      transactionId: filterParams?.transactionId,
      endDateFrom: formatFromDateParam(filterParams?.endDateRange?.[0]),
      endDateTo: formatToDateParam(filterParams?.endDateRange?.[1]),
      startDateFrom: formatFromDateParam(filterParams?.startDateRange?.[0]),
      startDateTo: formatToDateParam(filterParams?.startDateRange?.[1]),
      sortBy: SORT_BY[filterParams?.sortBy] ?? SORT_BY.claimTime,
      sortType: SORT_TYPE[filterParams?.sortType] ?? SORT_TYPE.ascend,
      pageSize: PAGE_SIZES.ACTIVE,
      page: page,
    };

    try {
      const res = await getStakeTransaction(params);
      const result = res?.data?.records;
      return result;
    } catch (err) {
      console.log("TableStake -> fetchDataActive -> err", err);
    }
  };

  const fetchDataEligible = async () => {
    const res = await getStakeEligible();
    return res?.data;
  };

  const loadData = async (page = 1) => {
    try {
      setTableLoading(true);
      let result = null;

      switch (viewType) {
        case STAKE_SUB_TAB.ACTIVE: {
          result = await fetchDataActive({ page });
          break;
        }
        case STAKE_SUB_TAB.ELIGIBLE: {
          result = await fetchDataEligible();
          break;
        }
        default:
          break;
      }

      if (result) {
        const items = result;
        setRows(items);
      } else {
        setRows([]);
      }
    } catch (err) {
      console.log(err);
      setRows([]);
    } finally {
      setTableLoading(false);
    }
  };

  const rowsToView = useMemo(() => {
    if (viewType === STAKE_SUB_TAB.ELIGIBLE) {
      if (viewEligibleOnly) {
        return (rows || []).filter((record) => {
          return (
            moment(new Date()).isAfter(new Date(record.validStakeTimeFrom)) &&
            moment(new Date()).isBefore(new Date(record.validStakeTimeTo)) &&
            record.remainAmount > 0
          );
        });
      }
      return rows;
    }
    return rows;
  }, [rows, viewEligibleOnly, viewType]);

  const STAKE_OPTION_COLUMNS = {
    ACTIVE: [
      {
        title: T("Stake Amount"),
        dataIndex: "amount",
        key: "amount",
        align: "right",
        className: "justify-end",
        width: 200,
        fixed: "left",
        sorter: true,
        render: (text, record, index) => (
          <TextCellNormal>
            <NumberFormat
              value={record.amount}
              displayType={"text"}
              thousandSeparator={true}
              suffix={` ${record.tokenName}`}
              decimalScale={3}
            />
          </TextCellNormal>
        ),
      },
      {
        title: T("Duration"),
        dataIndex: "duration",
        key: "duration",
        align: "right",
        width: 200,
        fixed: "left",
        render: (text, record, index) => (
          <TextCellNormal>
            <span className="capitalize">
              {record.duration === 1
                ? T(`{year} Year`).replace("{year}", 1)
                : T(`{year} Years`).replace("{year}", record.duration)}
            </span>
          </TextCellNormal>
        ),
      },
      {
        title: T("Interest rate"),
        dataIndex: "interestRate",
        key: "interestRate",
        align: "right",
        width: 150,
        render: (text, record, index) => (
          <TextCellNormal>{formatPercentage(text, 0)}</TextCellNormal>
        ),
      },
      {
        title: T("Interest Amount"),
        dataIndex: "estReward",
        key: "estReward",
        align: "right",
        width: 200,
        render: (text, record, index) => (
          <TextCellNormal>
            <span className="text-[#F12E11] font-[600]">
              {`${formatCurrency(
                +(record?.amount ?? 0) * +(record?.interestRate ?? 0),
                2
              )} SGT`}
            </span>
          </TextCellNormal>
        ),
      },
      {
        title: T("Start date"),
        dataIndex: "startTime",
        key: "startTime",
        align: "center",
        className: "justify-center",
        width: 180,
        sorter: true,
        render: (text, record, index) => (
          <TextCellNormal>
            {dateFormatNumber(text, "YYYY/MM/DD")}
          </TextCellNormal>
        ),
      },
      {
        title: T("End date"),
        dataIndex: "claimTime",
        key: "claimTime",
        align: "center",
        className: "justify-center",
        width: 180,
        sorter: true,
        render: (text, record, index) => (
          <TextCellNormal>
            {dateFormatNumber(text, "YYYY/MM/DD")}
          </TextCellNormal>
        ),
      },
      {
        title: T("Transaction ID"),
        dataIndex: "txHash",
        key: "txHash",
        align: "center",
        width: 200,
        render: (text, record, index) =>
          text ? (
            <div className="w-[150px] mx-auto">
              <Copy
                textStyle={{ fontWeight: 400, fontSize: 16 }}
                cutText={true}
                splitFont={5}
                splitFontLg={5}
                numDot={3}
                text={text}
                icon={<CopyIcon />}
              />
            </div>
          ) : (
            <></>
          ),
      },
    ],
    ELIGIBLE: [
      {
        title: T("Token"),
        dataIndex: "name",
        key: "name",
        width: 110,
        render: (text, record, index) => {
          return (
            <CellRowImage style={{ minWidth: 60 }}>
              <img
                alt=""
                style={{ width: 28, height: 28 }}
                src={`/assets/images/otc/crypto/${getCoinCodeImage(
                  text
                )?.toLowerCase()}.svg`}
              />
              <span style={{ marginLeft: 16 }}>{text}</span>
            </CellRowImage>
          );
        },
      },
      {
        title: T("Description"),
        dataIndex: "description",
        key: "description",
        align: "center",
        width: 160,
        render: (text, record) => (
          <TextCellNormal className="leading-6">
            {record.name === "SGT"
              ? T("Walking_reward") + ` ${record.description}`
              : ""}
            {record.name === "SOTa"
              ? T("Released") + ` ${record.description}`
              : ""}
          </TextCellNormal>
        ),
      },
      {
        title: T("Exchange amount"),
        dataIndex: "exercisedAmount",
        key: "exercisedAmount",
        align: "center",
        width: 160,
        render: (text, record, index) => (
          <TextCellNormal>
            <NumberFormat
              value={record.exercisedAmount}
              displayType={"text"}
              thousandSeparator={true}
              suffix={` ${record.stakeCurrency || "SGT"}`}
              decimalScale={3}
            />
          </TextCellNormal>
        ),
      },
      {
        title: T("Staking Amount"),
        dataIndex: "stakedAmount",
        key: "stakedAmount",
        align: "center",
        width: 160,
        render: (text, record, index) => (
          <TextCellNormal>
            <NumberFormat
              value={record.stakedAmount}
              displayType={"text"}
              thousandSeparator={true}
              suffix={` ${record.stakeCurrency || "SGT"}`}
              decimalScale={3}
            />
          </TextCellNormal>
        ),
      },
      {
        title: (
          <div className="flex items-center justify-center">
            {T("Remain amount")}{" "}
            <Tooltip
              trigger={size.width < 768 ? "click" : "hover"}
              onClick={(e) => e.stopPropagation()}
              className="cursor-pointer mx-[5px]"
              color={"#EAF2FF"}
              overlayClassName={"note-tooltip-10"}
              title={
                <div>
                  <div>
                    {T(
                      "The remaining amount represents the eligible quantity that can be staked in the option."
                    )}
                  </div>
                  <div>{T("This value is determined based on:")}</div>
                  <ul className="list-disc pl-6">
                    <li>{T("User's exercised tokens")}</li>
                    <li>{T("The tokens currently staked")}</li>
                    <li>
                      {T(
                        "The amount that falls within the eligible staking period for that specific token."
                      )}
                    </li>
                  </ul>
                </div>
              }
            >
              <span>
                <InfoTooltipIcon />
              </span>
            </Tooltip>
          </div>
        ),
        dataIndex: "remainAmount",
        key: "remainAmount",
        align: "center",
        width: 160,
        render: (text, record, index) => (
          <TextCellNormal>
            <NumberFormat
              value={record.remainAmount}
              displayType={"text"}
              thousandSeparator={true}
              suffix={` ${record.stakeCurrency || "SGT"}`}
              decimalScale={3}
            />
          </TextCellNormal>
        ),
      },
      {
        title: T("Eligible from"),
        dataIndex: "validStakeTimeFrom",
        key: "validStakeTimeFrom",
        align: "center",
        width: 150,
        render: (text, record, index) => (
          <TextCellNormal>
            <div className="flex justify-center mx-auto w-[100px]">
              <span className="whitespace-break-spaces  leading-6">
                {dateFormatNumber(
                  record.validStakeTimeFrom,
                  "YYYY/MM/DD HH:mm:ss"
                )}
              </span>
            </div>
          </TextCellNormal>
        ),
      },
      {
        title: T("Eligible to"),
        dataIndex: "validStakeTimeFrom",
        key: "validStakeTimeFrom",
        align: "center",
        width: 150,
        render: (text, record, index) => (
          <TextCellNormal>
            <div className="flex justify-center mx-auto w-[100px]">
              <span className="whitespace-break-spaces leading-6">
                {dateFormatNumber(
                  record.validStakeTimeTo,
                  "YYYY/MM/DD HH:mm:ss"
                )}
              </span>
            </div>
          </TextCellNormal>
        ),
      },
      {
        title: T("Status"),
        dataIndex: "releaseOn",
        key: "releaseOn",
        align: "center",
        width: 100,
        render: (text, record, index) => {
          if (
            moment(new Date()).isBefore(new Date(record.validStakeTimeFrom))
          ) {
            return <TextCellNormal>{T("Incoming")}</TextCellNormal>;
          } else if (
            moment(new Date()).isAfter(new Date(record.validStakeTimeFrom)) &&
            moment(new Date()).isBefore(new Date(record.validStakeTimeTo))
          ) {
            if (record.remainAmount === 0)
              return <TextCellNormal>{T("Fully Stake")}</TextCellNormal>;
            if (record.remainAmount > 0)
              return (
                <TextCellNormal>
                  <span className="text-[#0F8ACB]">{T("Eligible")}</span>
                </TextCellNormal>
              );
          } else {
            if (record.remainAmount === 0)
              return <TextCellNormal>{T("Fully Stake")}</TextCellNormal>;
            return (
              <TextCellNormal>
                <span className="text-[#E6665C] leading-6">
                  {T("Ineligible")}
                </span>
              </TextCellNormal>
            );
          }
        },
      },
    ],
  };

  const columns = useMemo(() => {
    if (loading) return [];
    switch (viewType) {
      case STAKE_SUB_TAB.ACTIVE:
        return STAKE_OPTION_COLUMNS.ACTIVE;
      case STAKE_SUB_TAB.ELIGIBLE:
        return STAKE_OPTION_COLUMNS.ELIGIBLE;
      default:
        return [];
    }
  }, [viewType, language, loading]);

  const onCreateStake = async () => {
    navigate("/stake-request");
  };

  const headerTitle = useMemo(() => {
    switch (viewType) {
      case STAKE_SUB_TAB.ACTIVE:
        return T("Active Staking Balance");
      case STAKE_SUB_TAB.ELIGIBLE:
        return T("Eligible Staking Balance");
      default:
        return "";
    }
  }, [viewType, T]);

  const renderSlideBanner = () => {
    return (
      <div className="flex justify-start mt-[14px] lg:mt-[24px] flex-wrap lg:flex-nowrap">
        <SlideBannerOuterContainer>
          <SlideBannerContainer className="gap-[16px] showOver">
            <SwiperWraper
              ref={swiperRef}
              slidesPerView={getSlidePreview()}
              spaceBetween={getSpaceBetween()}
              grabCursor={true}
              pagination={false}
              watchOverflow={true}
              onSwiper={(s) => {}}
            >
              <SwiperSlideWrapper key={1}>
                <CardSlideHeader
                  isMobile={isMobile}
                  onClick={() => handleViewTypeChange(STAKE_SUB_TAB.ACTIVE)}
                  active={viewType === STAKE_SUB_TAB.ACTIVE}
                  title={T(`Active Staking Balance`)}
                  balance={`${RoundNumberOfDigitSGT(stats?.stakedBalance)} SGT`}
                  bannerIcon={StakingTabIcons.ACTIVE_BALANCE}
                />
              </SwiperSlideWrapper>
              <SwiperSlideWrapper key={2}>
                <CardSlideHeader
                  isMobile={isMobile}
                  onClick={() => handleViewTypeChange(STAKE_SUB_TAB.ELIGIBLE)}
                  active={viewType === STAKE_SUB_TAB.ELIGIBLE}
                  title={`Eligible Staking Balance`}
                  balance={`${RoundNumberOfDigitSGT(
                    stats?.availableBalance
                  )} SGT`}
                  bannerIcon={StakingTabIcons.ELIGIBLE_BALANCE}
                />
              </SwiperSlideWrapper>
            </SwiperWraper>
          </SlideBannerContainer>
        </SlideBannerOuterContainer>

        <div className="flex justify-end w-full">
          <button
            type="button"
            className="bg-black text-[16px] rounded-[10px] font-semibold min-w-full lg:min-w-[130px] h-[50px] mt-[30px] lg:mt-0"
            onClick={(e) => {
              onCreateStake();
            }}
          >
            <span className="text-white">{T("Stake")}</span>
          </button>
        </div>
      </div>
    );
  };

  const renderHeader = () => {
    return (
      <>
        <div className="flex items-center justify-end lg:justify-between lg:pt-[40px] pt-[15px]">
          <div className="hidden lg:block text-[20px] font-semibold">
            {headerTitle}
          </div>

          {[STAKE_SUB_TAB.ACTIVE].includes(viewType) && (
            <>
              <div
                className={`flex justify-center items-center px-[14px] py-[10px] 
                  bg-white gap-[8px] rounded-full lg:rounded-[10px] cursor-pointer`}
                onClick={() => toggleFilter()}
              >
                <span>
                  {" "}
                  <FilterIcon />{" "}
                </span>
                <span className={`text-sm text-black`}>{T("Filter")}</span>
              </div>
            </>
          )}

          {viewType === STAKE_SUB_TAB.ELIGIBLE && (
            <div className="flex justify-end pt-5 lg:pt-[40px] items-center gap-1">
              <span>{T("Show eligible token only")}</span>
              <div className="lg:w-[42px] w-8" onClick={() => onChangeSwitch()}>
                {viewEligibleOnly ? (
                  <svg
                    className="w-full object-contain"
                    width="42"
                    height="25"
                    viewBox="0 0 42 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.8125 0.1875C5.3025 0.1875 0 5.5675 0 12.1875C0 18.8075 5.3025 24.1875 11.8125 24.1875H30.1875C36.6936 24.1875 42 18.7968 42 12.1875C42 5.57817 36.6936 0.1875 30.1875 0.1875H11.8125ZM30.1875 2.85417C35.2787 2.85417 39.375 7.0155 39.375 12.1875C39.375 17.3595 35.2787 21.5208 30.1875 21.5208C25.0963 21.5208 21 17.3595 21 12.1875C21 7.0155 25.0963 2.85417 30.1875 2.85417Z"
                      fill="black"
                    />
                  </svg>
                ) : (
                  <svg
                    className="w-full object-contain"
                    width="42"
                    height="25"
                    viewBox="0 0 42 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M30.1875 24.8125C36.6975 24.8125 42 19.4325 42 12.8125C42 6.1925 36.6975 0.8125 30.1875 0.812499L11.8125 0.812497C5.30644 0.812497 1.62688e-06 6.20316 1.04907e-06 12.8125C4.71267e-07 19.4218 5.30644 24.8125 11.8125 24.8125L30.1875 24.8125ZM11.8125 22.1458C6.72131 22.1458 2.625 17.9845 2.625 12.8125C2.625 7.6405 6.72132 3.47916 11.8125 3.47916C16.9037 3.47916 21 7.6405 21 12.8125C21 17.9845 16.9037 22.1458 11.8125 22.1458Z"
                      fill="#E0E0E0"
                    />
                  </svg>
                )}
              </div>
            </div>
          )}
        </div>

        <FilterStake
          show={showFilter}
          isMobile={isMobile}
          viewType={viewType}
          filterParams={filterParams}
          onUpdate={setFilterParams}
          onSearch={handleSearch}
          onReset={handleReset}
          onClose={() => {
            setShowFilter(false);
          }}
        />
      </>
    );
  };

  const renderList = () => {
    return (
      <div className="mt-[20px] lg:mt-[20px]">
        <DesktopContainer>
          <ContainerTable>
            <TableView
              key={tableKey}
              locale={{ emptyText: <EmptyTable T={T} /> }}
              scroll={{ x: true }}
              tableLayout={"fixed"}
              pagination={false}
              dataSource={rowsToView}
              columns={columns}
              loading={tableLoading}
              isClickRow
              onRow={(record, rowIndex) => {
                return {
                  onClick: (event) => {},
                };
              }}
              onChange={handleTableChange}
            />
          </ContainerTable>
        </DesktopContainer>

        <MobileContainer>
          {tableLoading ? (
            <>{renderReloadingIcon()}</>
          ) : (
            <>
              {rowsToView?.length ? (
                rowsToView?.map((item, index) => (
                  <ContainerTableStakeMobile>
                    <WalletRowStake
                      key={index}
                      viewType={viewType}
                      item={item}
                    />
                  </ContainerTableStakeMobile>
                ))
              ) : (
                <div className="w-full flex justify-center pt-[10px]">
                  <EmptyTableMobile T={T} />
                </div>
              )}
            </>
          )}
        </MobileContainer>
      </div>
    );
  };

  const renderReloadingIcon = () => {
    return (
      <div className="w-full flex justify-center pt-6">
        <LoadingList />
      </div>
    );
  };

  return (
    <>
      {renderSlideBanner()}
      {renderHeader()}
      {tabLoading ? renderReloadingIcon() : renderList()}
    </>
  );
};
